var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-checkbox d-flex justify-content-center align-items-center",class:{ 
     'has-border': _vm.border,
     'disabled': _vm.disabled,
 },on:{"click":function($event){return _vm.clickChecked()}}},[(_vm.boolean)?_c('img',{attrs:{"src":require("@/assets/images/tvm-assets/1920_icon_red_checked.svg")}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }